import { createStyle } from "@gluestack-style/react";

export const FormControlLabel = createStyle({
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  mb: "$1",
});
